<template>
  <v-menu offset-y left transition="slide-y-transition" :close-on-content-click="true">
    <template v-slot:activator="{ on }">
      <div class="user-chip" v-on="on">
        <avatar
          v-if="isAuthenticated.user"
          :size="26"
          :backgroundColor="setColor(isAuthenticated.user)"
          :username="isAuthenticated.user.nombre"
          class="uc-avatar"
        />
        <div class="uc-info d-none d-md-flex flex-column">
          <span class="uc-name">{{ isAuthenticated.user && isAuthenticated.user.nombre }}</span>
          <span class="uc-role">{{ userRole }}</span>
        </div>
        <i class="mdi mdi-chevron-down uc-chevron" />
      </div>
    </template>

    <v-list dense nav class="user-menu">
      <v-list-item
        v-for="(item, index) in menu"
        :key="index"
        :to="item.link"
        :exact="item.exact"
        :disabled="item.disabled"
        link
      >
        <v-list-item-icon>
          <v-icon small :class="{ 'grey--text': item.disabled }">{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ item.key ? $t(item.key) : item.text }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider class="my-1" />

      <v-list-item to="/setting2fa" link>
        <v-list-item-icon><v-icon small>mdi-lock</v-icon></v-list-item-icon>
        <v-list-item-content><v-list-item-title>2FA</v-list-item-title></v-list-item-content>
      </v-list-item>

      <v-divider class="my-1" />

      <v-list-item @click="logout()">
        <v-list-item-icon><v-icon small>mdi-logout-variant</v-icon></v-list-item-icon>
        <v-list-item-content><v-list-item-title>{{ $t('menu.logout') }}</v-list-item-title></v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { setColor } from "@/helpers";
import config from "../../configs";
import { mapGetters } from "vuex";
import Avatar from "vue-avatar";
import axios from "axios";
import router from '@/router';

export default {
  components: { Avatar },

  data: () => ({
    menu: config.toolbar.user
  }),

  created() {
    this.axiosInterceptorId = this.authListener();
  },

  beforeDestroy() {
    axios.interceptors.response.eject(this.axiosInterceptorId);
  },

  computed: {
    ...mapGetters(["isAuthenticated", "authToken"]),

    userRole() {
      const user = this.isAuthenticated?.user;
      if (!user) return '';
      if (user.roles?.length) return user.roles[0].name;
      if (user.permisos?.some(p => p.name === 'tickets.view')) return 'Administrador';
      return 'Usuario';
    },
  },

  methods: {
    setColor,

    authListener() {
      return axios.interceptors.response.use(
        response => response,
        error => {
          const status = error.response?.status;
          const message = error.response?.data?.message ?? '';
          const isUnauthenticated = status === 401 || (status === 500 && message === 'Unauthenticated.');
          if (isUnauthenticated) {
            localStorage.clear();
            router.push('/auth/signin');
          }
          return Promise.reject(error);
        }
      );
    },

    async logout() {
      const url = this.authToken.options.baseUrl + "/" + this.authToken.options.logoutUrl;
      this.$Progress.start();
      return await axios.get(url)
        .then(() => {
          setTimeout(() => {
            router.push('/auth/signin');
            this.$store.commit("logout");
            this.$Progress.finish();
          }, 1000);
        })
        .catch(error => {
          console.log(error);
          this.$Progress.fail();
        });
    }
  }
};
</script>

<style>
/* ── user-chip (mockup-faithful) ── */
.user-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 36px;
  padding: 0 8px 0 3px;
  border-radius: 999px;
  cursor: pointer;
  border: 1px solid;
  transition: background 120ms;
  flex-shrink: 0;
}

.theme--dark .user-chip {
  background: rgba(255, 255, 255, 0.04);
  border-color: rgba(255, 255, 255, 0.08);
}
.theme--dark .user-chip:hover {
  background: rgba(255, 255, 255, 0.08);
}
.theme--light .user-chip {
  background: rgba(0, 0, 0, 0.03);
  border-color: rgba(0, 0, 0, 0.09);
}
.theme--light .user-chip:hover {
  background: rgba(0, 0, 0, 0.06);
}

.uc-avatar { flex-shrink: 0; }
.uc-info { line-height: 1; gap: 1px; }
.uc-name { font-size: 12.5px; font-weight: 500; white-space: nowrap; max-width: 120px; overflow: hidden; text-overflow: ellipsis; }
.theme--dark .uc-name  { color: #e8eaef; }
.theme--light .uc-name { color: #1b1d22; }
.uc-role { font-size: 10.5px; white-space: nowrap; }
.theme--dark .uc-role  { color: #6d7585; }
.theme--light .uc-role { color: #8a90a0; }
.uc-chevron { font-size: 15px; flex-shrink: 0; }
.theme--dark .uc-chevron  { color: #6d7585; }
.theme--light .uc-chevron { color: #8a90a0; }

/* dropdown list */
.user-menu { min-width: 180px; }
</style>
